import React, { useState } from 'react';

import { MoodWrapper } from "../../container/accountSettings.styles";

import { changeMood } from "../../../../Header/store/headerSlice";
import { Switch as AntSwitch } from 'antd';
import styled from "styled-components";
import MoodIcon from "../../../../assets/icon/mood.svg";

import {HeaderUserPosition} from "../../../../Header/styled";
import {useAppDispatch, useAppSelector} from "@features/store/store";

const SwitchMood = styled(AntSwitch)`
    .ant-switch-handle::before {
        content: "";
        display: block;
        width: 20px;  
        height: 20px; 
        background-image: url(${MoodIcon});
        background-size: cover;
        background-position: center;
    }
`;

const Mood: React.FC = () => {
    const [isChecked, setIsChecked] = useState(false);
    const dispatch = useAppDispatch(); // fixed hook name
    const themeMode = useAppSelector((state) => state.header.themeMode); // Get mode from Redux

    const selectMood = (checked: boolean) => {
        dispatch(changeMood());
        setIsChecked(checked);

    };

    return (
        <MoodWrapper>
            <SwitchMood defaultChecked={isChecked} onChange={selectMood} />
            <HeaderUserPosition align="right">
                {isChecked ? "Dark mode" : "Light mode"}
            </HeaderUserPosition>
        </MoodWrapper>
    );
};

export default Mood;
